import ApiModel from './globals/ApiModel';

export default class NotificationModel extends ApiModel {
  static get path() {
    return '/backend/notifications/{?id}';
  }
}
